module.exports = __webpack_public_path__ + "static/img/智能评估_0.0354df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/智能评估_0.jpg
// module id = wcWq
// module chunks = 1